
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseAiCatalogItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AiCatalogItem"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"itemType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"descriptionHtml"},"arguments":[],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gl_introduced"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"StringValue","value":"19.1.0","block":false}}]}]},{"kind":"Field","name":{"kind":"Name","value":"foundationalFlowReference"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"foundational"},"arguments":[],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gl_introduced"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"StringValue","value":"18.10.0","block":false}}]}]},{"kind":"Field","name":{"kind":"Name","value":"verificationLevel"},"arguments":[],"directives":[]},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AiCatalogAgent"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"foundational"},"arguments":[],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gl_introduced"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"StringValue","value":"18.7.0","block":false}}]}]},{"kind":"Field","name":{"kind":"Name","value":"foundationalAgentReference"},"arguments":[],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gl_introduced"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"StringValue","value":"19.2.0","block":false}}]}]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AiCatalogFlow"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"foundational"},"arguments":[],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gl_introduced"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"StringValue","value":"18.7.0","block":false}}]}]}]}},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"public"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"softDeleted"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"latestVersion"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"versionName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"username"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"webUrl"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userPermissions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminAiCatalogItem"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"starCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"starred"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"last30DayUsageCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"visibility"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"__typename"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":768}};
    doc.loc.source = {"body":"fragment BaseAiCatalogItem on AiCatalogItem {\n  id\n  createdAt\n  itemType\n  description\n  descriptionHtml @gl_introduced(version: \"19.1.0\")\n  foundationalFlowReference\n  foundational @gl_introduced(version: \"18.10.0\")\n  verificationLevel\n  ... on AiCatalogAgent {\n    foundational @gl_introduced(version: \"18.7.0\")\n    foundationalAgentReference @gl_introduced(version: \"19.2.0\")\n  }\n  ... on AiCatalogFlow {\n    foundational @gl_introduced(version: \"18.7.0\")\n  }\n  name\n  public\n  updatedAt\n  softDeleted\n  latestVersion {\n    id\n    versionName\n    createdAt\n    updatedAt\n    createdBy {\n      id\n      name\n      username\n      webUrl\n    }\n  }\n  userPermissions {\n    adminAiCatalogItem\n  }\n  starCount\n  starred\n  last30DayUsageCount\n  visibility\n  __typename\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["BaseAiCatalogItem"] = oneQuery(doc, "BaseAiCatalogItem");
        
